import { type IVideo } from 'src/models';
import VIDEO_TYPES from './types';

function create(video: FormData) {
	return {
		type: VIDEO_TYPES.CREATE,
		payload: { video },
	};
}

function update(video: IVideo) {
	return {
		type: VIDEO_TYPES.UPDATE,
		payload: { video },
	};
}

function remove(id: number) {
	return {
		type: VIDEO_TYPES.REMOVE,
		payload: { id },
	};
}

function markSeen(videoId: number, sectionId: number) {
	return {
		type: VIDEO_TYPES.MARK_SEEN,
		payload: { videoId, sectionId },
	};
}

function updateOrder(sectionId: number, videos: IVideo[]) {
	return {
		type: VIDEO_TYPES.UPDATE_ORDER,
		payload: { sectionId, videos },
	};
}

function handleActivation(id: number, value: boolean) {
	return {
		type: VIDEO_TYPES.HANDLE_ACTIVATION,
		payload: { id, value },
	};
}

const videoActions = {
	create,
	update,
	remove,
	markSeen,
	updateOrder,
	handleActivation,
};

export default videoActions;
